<template>
  <div class="em-block form-style">
    <div class="em-child">
      <h3>New Menu Folder</h3>

      <div>
        <label for="folder-name">Name</label>
        <input v-model="newFolder.name" type="text" id="folder-name">
      </div>

      <div class="cta">
        <button @click="cancel" type="button" class="btn red outline block">Cancel</button>
        <button @click="save" type="button" class="btn green block" :disabled="newFolder.name.length < 1">Save</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import BookmarkFolder from "../../models/bookmarkFolder";
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";
  import configureSidebarInterfaceStoreMixin from "../../mixins/configureSidebarInterfaceStoreMixin";

  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    state: [
      'bookmarkMenu',
    ],
    actions: [
      'createBookmarkFolder',
    ],
  });

  export default Vue.extend({
    mixins: [bookmarkMenuStoreMixin, configureSidebarInterfaceStoreMixin],
    data: function(): object {
      return {
        newFolder: new BookmarkFolder(),
      }
    },
    methods: {
      cancel(): void {
        this.resetInterface({bookmarkMenu: this.bookmarkMenu});
      },
      save(): void {
        this.createBookmarkFolder({bookmarkFolder: this.newFolder}).then(() => {
          this.setInterfaceMode({mode: ConfigureSidebarModes.showFolder, selected: this.newFolder});
        });
      },
    },
  })
</script>